/**
 * 地图指标：起点/落点经纬度 + 是否连线（表头行 + 数据行）
 * 表头示例：{ x: "起点经纬度", y: "落点经纬度", label: "是否连线" }
 * 数据行示例：{ x: "39.9042,116.4074", y: "9.0765,7.3986", label: 1 }
 */

/** 航线连线与动效默认颜色（侧栏可配置 mapRouteLineColor，未配置时用此值） */
export const MAP_ROUTE_LINE_COLOR = '#5ED5FE'

export function isLatLngRouteIndicatorDataList (dataList) {
  if (!Array.isArray(dataList) || dataList.length < 2) return false
  const h = dataList[0]
  if (!h || typeof h !== 'object') return false
  return String(h.x) === '起点经纬度' &&
    String(h.y) === '落点经纬度' &&
    String(h.label) === '是否连线'
}

/** 数据为 "纬度,经度"（与示例一致），转为 ECharts geo 用的 [经度, 纬度] */
export function parseLatLngStringToGeoCoord (str) {
  if (str == null || str === '') return null
  const parts = String(str).trim().split(',').map(p => parseFloat(p.trim()))
  if (parts.length !== 2 || parts.some(n => Number.isNaN(n))) return null
  const lat = parts[0]
  const lng = parts[1]
  return [lng, lat]
}

function isLinkEnabled (label) {
  return label === 1 || label === '1' || label === true
}

/**
 * @param {Array} dataList 含首行表头
 * @returns {{ scatter: Array, lines: Array }}
 */
export function buildMapRouteOverlayFromDataList (dataList) {
  const scatter = []
  const lines = []
  const rows = dataList.slice(1)
  rows.forEach((row, i) => {
    const from = parseLatLngStringToGeoCoord(row.x)
    const to = parseLatLngStringToGeoCoord(row.y)
    if (!to) return
    scatter.push({
      name: `落点${i + 1}`,
      value: to,
    })
    if (isLinkEnabled(row.label) && from) {
      lines.push({
        coords: [from, to],
        lineStyle: { color: MAP_ROUTE_LINE_COLOR },
      })
    }
  })
  return { scatter, lines }
}

export function mergeMapRouteOverlayParts (parts) {
  const scatter = []
  const lines = []
  parts.forEach(p => {
    if (p.scatter?.length) scatter.push(...p.scatter)
    if (p.lines?.length) lines.push(...p.lines)
  })
  if (!scatter.length && !lines.length) return null
  return { scatter, lines }
}
